import React from "react";
import { capitalizeFirstLetterAndRemainingSmallForEachWord } from "../../../utils/commonUtils";

type SelectionChipsProps = {
  value: string;
  selected?: boolean;
  onclick?: (material: string) => void;
  trendsSidebarSnapshotExpandedView?: boolean;
  sideBarSelection?: boolean;
  preserveCase?: boolean;
};

const SelectionChips: React.FC<SelectionChipsProps> = ({
  value,
  selected = false,
  onclick,
  trendsSidebarSnapshotExpandedView = false,
  sideBarSelection = false,
  preserveCase = false,
}) => {
  return (
    <div
      className={`inline-flex items-center justify-center py-1 px-2 rounded-full 
      ${selected ? "bg-gray81" : "bg-white"} 
      border-[0.8px] border-secondary text-[10px] 
      ${onclick ? "mr-2 mb-2" : ""} 
      ${onclick && !trendsSidebarSnapshotExpandedView ? "cursor-pointer" : ""}   whitespace-nowrap leading-none 
  backface-hidden transform-gpu`}
      onClick={() => onclick && onclick(value)}
      style={{
        position: "relative",
        ...(sideBarSelection ? {} : { zIndex: 1000 }),
      }}
    >
      {preserveCase
        ? value
        : capitalizeFirstLetterAndRemainingSmallForEachWord(value)}
    </div>
  );
};

export default SelectionChips;
